import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { CloneAndConversionService as BaseCloneAndConversionService } from "../../../shared/services/cloneAndConversionService";
import { Machine } from "../../models/machine";
import { MachineConfiguration } from "../../models/machineConfiguration";
import { IQService } from "angular";

export const vsServiceName = "cloneAndConversionService";

export class CloneAndConversionService extends BaseCloneAndConversionService<
  Machine,
  MachineConfiguration
> {
  static $inject = [ServerUtilityName, "$q"];
  constructor(serverUtility: ServerUtility, $q: IQService) {
    super(serverUtility, $q);
  }

  protected override prepareCloneConfiguration(
    cloneConfiguration: MachineConfiguration,
  ): MachineConfiguration {
    const result = super.prepareCloneConfiguration(cloneConfiguration);
    result.Section = undefined;
    result.Bank = undefined;
    result.Position = undefined;

    result.WarehouseLocation = undefined;
    result.MachineDecommissionType = undefined;
    result.MachineDecommissionTypeId = undefined;
    result.MachineWarehouseType = undefined;
    result.MachineConversionTypeId = undefined;
    result.MachineConversionType = undefined;
    result.SlotNumber = undefined;

    /* TODO - null out client specific location and configuration type fields here */

    return result;
  }

  protected override prepareConversionConfiguration(
    conversionConfiguration: MachineConfiguration,
    currentConfiguration: MachineConfiguration,
  ): MachineConfiguration {
    return {
      ...super.prepareConversionConfiguration(
        conversionConfiguration,
        currentConfiguration,
      ),
      Section: currentConfiguration.Section,
      Bank: currentConfiguration.Bank,
      Position: currentConfiguration.Position,
      WarehouseLocation: currentConfiguration.WarehouseLocation,
      MachineDecommissionType: undefined,
      MachineDecommissionTypeId: undefined,
      MachineWarehouseType: undefined,
      MachineConversionTypeId: undefined,
      MachineConversionType: undefined,
      SlotNumber: undefined,
      /* TODO - fill in client specific fields that should be carried over from converted machine, not the template for the conversion */
    };
  }
}
